var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "c-search-box",
        { on: { enter: _vm.getList } },
        [
          _c("template", { slot: "search" }, [
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-plant", {
                  attrs: { type: "search", name: "plantCd" },
                  model: {
                    value: _vm.searchParam.plantCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "plantCd", $$v)
                    },
                    expression: "searchParam.plantCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-dept", {
                  attrs: {
                    type: "search",
                    label: "LBLDEPT",
                    name: "seniorDeptCd",
                  },
                  model: {
                    value: _vm.searchParam.seniorDeptCd,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "seniorDeptCd", $$v)
                    },
                    expression: "searchParam.seniorDeptCd",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-field", {
                  attrs: {
                    type: "user",
                    label: "LBL0010211",
                    name: "seniorUserId",
                  },
                  model: {
                    value: _vm.searchParam.seniorUserId,
                    callback: function ($$v) {
                      _vm.$set(_vm.searchParam, "seniorUserId", $$v)
                    },
                    expression: "searchParam.seniorUserId",
                  },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3" },
              [
                _c("c-datepicker", {
                  attrs: { range: true, name: "period", label: "LBL0010212" },
                  model: {
                    value: _vm.period,
                    callback: function ($$v) {
                      _vm.period = $$v
                    },
                    expression: "period",
                  },
                }),
              ],
              1
            ),
          ]),
        ],
        2
      ),
      _c(
        "c-table",
        {
          ref: "seniorDismissal",
          attrs: {
            title: "선해임 이력관리 목록",
            tableId: "seniorDismissal",
            columns: _vm.grid.columns,
            gridHeight: _vm.grid.height,
            merge: _vm.grid.merge,
            data: _vm.grid.data,
            rowKey: "seniorUserId",
            columnSetting: false,
            expandAll: true,
          },
        },
        [
          _c(
            "template",
            { slot: "table-button" },
            [
              _c(
                "q-btn-group",
                { attrs: { outline: "" } },
                [
                  _c("c-btn", {
                    attrs: { label: "LBLSEARCH", icon: "search" },
                    on: { btnClicked: _vm.getList },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c("c-dialog", { attrs: { param: _vm.popupOptions } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }